import React from 'react';

import HowToReturn from '../HowToReturn';
import Ups from '../svgs/Ups';

const UpsMethodContent = ({ hideTop = false }) => (
  <div className={`${hideTop ? 'card-group' : 'return-method card-group'}`}>
    {!hideTop && (
      <div className="card-group__item">
        <div className="card">
          <div className="card__content">
            <p>
              UPS will pick up your return package or you can drop off at a UPS store.
            </p>
            <div>
              <Ups className="svg-icon--185-wide" />
            </div>
          </div>
        </div>
      </div>
    )}

    <HowToReturn context="selectMethod" hideTitle />

    <div className="card-group__item">
      <div className="card">
        <div className="card__content">
          <div className="hgroup">
            <p className="body2">
              {'Don\'t have a printer or a cardboard box?'}
            </p>
            <p className="body3">
              {'Bring your devices to any UPS Store and they\'ll help you complete your return.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default UpsMethodContent;
